var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cat_404"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_404",
    "data-name": 404,
    className: "cls-2",
    d: "M63.31,12.37a23.79,23.79,0,0,1,20.51,0C96,18.29,99.25,34.55,98,46.83,95.36,71.74,72.07,87,48.88,89.47a83.59,83.59,0,0,1-31.67-2.63c-4.59-1.32-13.8-3.74-15.36-9.16a2.2,2.2,0,0,1-.06-.37c-.62-6.78,25.57-4.88,41-27.34C53.72,34.09,50.48,18.84,63.31,12.37Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat404);
export default __webpack_public_path__ + "static/media/cat_404.30c323358c8c078a1893ee4332326164.svg";
export { ForwardRef as ReactComponent };